export enum ORDER_AVAILABLE_PATH_TABS {
  BASE = 'base',
  PRICING = 'pricing',
  DEMAND = 'demand',
  BRIGADE_AND_WORK = 'brigade-and-work',
  DOCUMENTS = 'documents',
}
